export type PatientConsumableLineStockState = "none" | "reserved" | "issued" | "shortage";

export type PatientConsumableChargeStatus = "draft" | "billed" | "issued" | "cancelled";

export interface PatientConsumableChargeLine {
  id: string;
  productId: string;
  productLabel: string;
  quantity: number;
  stockState: PatientConsumableLineStockState;
}

export interface PatientConsumableCharge {
  id: string;
  chargeNumber: string;
  patientId: string;
  admissionId: string | null;
  stayId: string | null;
  lines: PatientConsumableChargeLine[];
  status: PatientConsumableChargeStatus;
  billingDocumentId: string | null;
  notes: string;
  createdAt: string;
  updatedAt: string;
}

export interface PatientConsumableChargeInput {
  patientId: string;
  admissionId?: string | null;
  stayId?: string | null;
  notes?: string;
  lines: Array<{
    productId: string;
    productLabel: string;
    quantity: number;
  }>;
}

export const PATIENT_CONSUMABLE_STATUS_LABELS: Record<PatientConsumableChargeStatus, string> = {
  draft: "Brouillon",
  billed: "Facturé",
  issued: "Délivré",
  cancelled: "Annulé",
};
